const targetSelector = ".kaching-bundles__subscriptions";
let subscriptionsBar = document.querySelector(targetSelector);

function injectStyles() {
  if (document.head.querySelector('style[data-custom-styles="sealsubs-ui"]'))
    return;

  const style = document.createElement("style");
  style.textContent = `
    .custom-subscription-ui {
      margin: 15px 0; padding: 15px;
       border: 1px solid var(--bar-selected-border-color) !important;
       // box-shadow: inset 0 0 0 1px var(--bar-border-color, rgba(0, 0, 0, .3));
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    @media (max-width: 767px) {
      .custom-subscription-ui {
        padding: 6px 14px 6px 20px !important;
        margin: 0 !important;
        min-height: 0 !important;
      }
      .custom-label {
        padding-top: 2px !important;
        padding-bottom: 2px !important;
      }
    }
    .custom-subscription-ui * {
      cursor: pointer;
      pointer-events: none; /* Add this line */
    }
    .custom-subscription-input {
      pointer-events: auto; /* Add this line */
    }
    .custom-label {
      display: flex;
      text-transform: none !important;
      flex-direction: column;
      margin-left: 18px;
      margin-bottom: auto;
      margin-top: auto;
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 16px;
      letter-spacing: .1em !important;
      flex-grow: 1;
    }
    .custom-checkbox { 
      margin: auto;
      width: 20px; height: 20px; flex-shrink: 0;
      border: 3px solid var(--bar-selected-border-color); transition: all 0.2s ease;
      position: relative;
      border-radius: 4px;
    }
    .custom-subscription-input:checked ~ .custom-checkbox {
      background: var(--bar-selected-border-color);
    }
    .custom-subscription-input:checked ~ .custom-checkbox::after {
      content: "✓";
      color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
    }
    .custom-subscription-input {
      position: absolute;
      opacity: 0;
      width: 20px;
      height: 20px;
    }
    .label-text { 
      font-weight: bold;
      color: #333; 
      flex-grow: 1; 
      line-height: 1.2;
          font-size: var(--bar-subtitle-font-size, 14px);
    font-weight: var(--bar-subtitle-font-weight);
    font-style: var(--bar-subtitle-font-style);
    font-size: 17px !important;
    color: var(--bar-title-color, #000);

    }
    .subscription-details { 
      color: #777; 
      font-size: 0.8em;
    font-style: var(--bar-subtitle-font-style);
    color: var(--bar-title-color, #000);
    }

     @media (min-width: 1000px) {
      .custom-label {
      font-size: 16px !important;
    }

    @media (max-width: 350px) {
      .label-text {
        font-size: 13px !important;
      }
      .custom-label {
        font-size: 13px !important;
      }
      .custom-subscription-ui {
      padding: 0px !important;
      }
    }
    
    @media (max-width: 600px) {
      .subscription-details { margin-left: 0; line-height: 1; }
      .label-text {
        margin-bottom: 5px;  
        white-space: nowrap;
        font-size: 14px;
        letter-spacing: 0px;
      }
      .custom-subscription-ui {
        padding: 5px !important;
      }
      .custom-subscription-input:checked ~ .custom-checkbox::after {
        font-size: 18px !important;
      }
      .custom-label {
        padding: 0px !important;
        margin-left: 10px;
        font-size: 14px;
      }
    }
  `;
  style.setAttribute("data-custom-styles", "sealsubs-ui");
  document.head.appendChild(style);
}

function overrideStyles() {
  if (document.head.querySelector('style[data-custom-styles="sealsubs-ui"]'))
    return;

  const style = document.createElement("style");
  style.textContent = `
    .custom-subscription-ui { 
      border: var(--bar-border-color) !important;
    }
  `;
  style.setAttribute("data-custom-styles-override", "sealsubs-ui");
  document.head.appendChild(style);
}

const elementFoundCallback = () => {
  injectStyles();
  overrideStyles();

  const container = document.querySelector(
    ".kaching-bundles__subscriptions.kaching-bundles__bars"
  );

  if (!container) return;

  // Store references to the original options
  const subscribeOption = container.querySelector(
    ".kaching-bundles__bar:nth-child(1)"
  );
  const oneTimeOption = container.querySelector(
    ".kaching-bundles__bar:nth-child(2)"
  );

  // Hide the original bars visually but keep them in DOM
  container.style.opacity = "0";
  container.style.height = "0";
  container.style.overflow = "hidden";
  container.style.margin = "0";
  container.style.padding = "0";

  const bundlesBar = document.querySelector(".kaching-bundles__block--loaded");

  // Create the custom UI element
  const customUI = document.createElement("div");
  customUI.className = "custom-subscription-ui";
  customUI.setAttribute("data-custom-ui", "true");

  // Build the custom UI structure
  customUI.innerHTML = `
    <input type="checkbox" id="custom-subscription-checkbox" class="custom-subscription-input" checked>
    <span class="custom-checkbox"></span>
    <label class="custom-label" for="custom-subscription-checkbox">
      <span class="label-text">Save 25% with Automatic Refills!</span>
      <div class="subscription-details">Zero commitment, Cancel Anytime</div>
    </label>
  `;

  // Insert the custom UI before the original container
  const checkbox = customUI.querySelector(".custom-subscription-input");
  bundlesBar.appendChild(customUI);
  // Set initial state (Subscribe option selected by default)
  subscribeOption.classList.add("kaching-bundles__bar--selected");
  oneTimeOption.classList.remove("kaching-bundles__bar--selected");

  // Handle checkbox changes
  const togglePlan = function () {
    checkbox.checked = !checkbox.checked;
    if (checkbox.checked) {
      // Select Subscribe option
      subscribeOption.classList.add("kaching-bundles__bar--selected");
      oneTimeOption.classList.remove("kaching-bundles__bar--selected");
      subscribeOption.click();
    } else {
      // Select One-time option
      oneTimeOption.classList.add("kaching-bundles__bar--selected");
      subscribeOption.classList.remove("kaching-bundles__bar--selected");
      oneTimeOption.click();
    }
  };

  // Add click handler to the entire UI container
  customUI.addEventListener("click", function (e) {
    // If clicking directly on the checkbox, let default behavior handle it
    if (e.target === checkbox) return;

    // For all other clicks, toggle the plan
    e.preventDefault();
    togglePlan();
  });

  // Also add change handler to the checkbox itself
  checkbox.addEventListener("change", function () {
    if (this.checked) {
      subscribeOption.classList.add("kaching-bundles__bar--selected");
      oneTimeOption.classList.remove("kaching-bundles__bar--selected");
      subscribeOption.click();
    } else {
      oneTimeOption.classList.add("kaching-bundles__bar--selected");
      subscribeOption.classList.remove("kaching-bundles__bar--selected");
      oneTimeOption.click();
    }
  });

  // Initialize the state
  checkbox.dispatchEvent(new Event("change"));
};

// Rest of your observer code remains the same
if (subscriptionsBar) {
  console.log("Element present immediately");
  elementFoundCallback();
} else {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.nodeType === Node.ELEMENT_NODE) {
            if (
              addedNode.matches(targetSelector) ||
              addedNode.querySelector(targetSelector)
            ) {
              elementFoundCallback();
              observer.disconnect();
              return;
            }
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
